var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-7 font-weight-bold"},[_c('span',{staticClass:"hidden-md-and-down",class:_vm.h2Class},[_vm._v("Time now ")]),_c('span',{staticClass:"font-weight-bold",class:_vm.h1Class},[_vm._v(_vm._s(_vm.formattedTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }